import React from 'react'
import InsideHospital from '../../components/Doctors/InsideHospital'

const HospitalPage = () => {
  return (
    <div>
      <InsideHospital/>
    </div>
  )
}

export default HospitalPage
